import { makeStyles } from "@material-ui/core";

const modalAcessoVinculadoStyles = makeStyles(() => ({
  containerEspacamento: {
    marginTop: "1rem"
  },
  textoBody1: {
    fontWeight: "bold", 
    marginBottom: "0.5rem"
  },
  textoBody1Color: {
    fontWeight: "bold",
    marginBottom: "0.5rem",
    color: "#49B6E7",
    cursor: "pointer",
  },
  linkConfigurar: {
    fontWeight: 700,
    fontSize: "0.8rem",
    color: "#49B6E7",
    cursor: "pointer",
  },
}));

export default modalAcessoVinculadoStyles;